class PriceServiceClient {
  constructor(integrationService) {
    this._integrationService = integrationService;
  }

  fetchPrices = async (customerId, postCode, productCodes) => {
    return this._integrationService.read({
      url: "trsonline/products/prices/batch",
      method: "POST",
      headers: {
        "Content-Type": "application/json;charset=UTF-8"
      },
      body: {
        customerId,
        postCode,
        products: productCodes.map(productCode => ({
          productCode,
          packs: ["PACK1", "PACK2"]
        }))
      }
    });
  }
}

export default PriceServiceClient;
